<div class="content">
  <a href="/">
    <img [src]="src" alt="logo">
  </a> 
</div>